<template>
    <v-card-title class="title grey--text text--darken-2 py-5">
        <v-btn
            icon
            class="elevation-0 grey--text"
            @click="$router.go(-1)"
            v-if="showBackButton"
        >
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-divider vertical class="mx-3 mr-5" v-if="showBackButton"></v-divider>

        {{ title }}
    </v-card-title>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        showBackButton: {
            type: Boolean,
            default: () => {
                return false
            },
        },
    },
}
</script>

<style></style>
